module.exports = __webpack_public_path__ + "static/media/spotlightRed.57f5b569.svg";